import React, { useEffect } from "react";
import "./RenderSelect.css";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { NavItem } from "react-bootstrap";
import { Typography } from "@mui/material";

const RenderSelectBlood = (props) => {
  const { value, options, name, onChange, placeholder, title, defaultValue,requiredprop
 } =
    props;
  //  useEffect(() => {
  //    if (options && options.length > 0 && !value) {
  //      onChange(name, options.id);
  //    }
  //  }, [options, name, onChange, value]);
  return (
    <>
      {title && (
        <Typography className="title-text">
          {title}

          {requiredprop && <span className="required-field">*</span>}
        </Typography>
      )}

      <Select
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        defaultValue={defaultValue}
        fullWidth
        size="small"
      >
        {options?.map((item) => {
          return (
            <MenuItem key={item.id} value={item.group}>
              {item.group}
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
};

export default RenderSelectBlood;
